<template>
    <v-container fluid>
        <v-card flat color="transparent">
            <v-card-title>
                <div class="d-flex align-center justify-space-between secondary--text w-100">
                    <div class="d-flex flex-column">
                        <span>Service Prices</span>
                    </div>
                </div>
            </v-card-title>

            <v-card-text class="mt-5">
                <v-row justify="center">
                    <v-col cols="12" v-if="error">
                        <dashboard-error></dashboard-error>
                    </v-col>
                    <v-col cols="12" v-else>
                        <v-row v-if="pricing.length === 0">
                            <v-col cols="12">
                                <dashboard-empty></dashboard-empty>
                            </v-col>
                        </v-row>
                        <v-row v-else>
                            <v-col cols="12" md="6" lg="4" xl="3" v-for="service in pricing" :key="service.name">
                                <v-card height="100%" class="d-flex flex-column">
                                    <v-card-title class="secondary--text">
                                        {{ service.name }}
                                    </v-card-title>
                                    <v-card-text>
                                        {{ service.description }}
                                    </v-card-text>
                                    <v-spacer></v-spacer>
                                    <v-card-text class="text-center">
                                        <div class="text-h5 secondary--text">{{ service.credit_price | creditToHuman }}</div>
                                        <div class="text--secondary">
                                            <b>credits</b>
                                            per
                                            <b>{{ service.unit }}</b>
                                        </div>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <div>
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn v-bind="attrs" v-on="on" icon :href="service.documentation_link" target="_blank">
                                                        <v-icon>mdi-book-open-variant</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Documentation</span>
                                            </v-tooltip>
                                        </div>
                                    </v-card-actions>
                                </v-card>
                            </v-col>
                        </v-row>
                        <div class="d-flex align-center"></div>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import dashboard from '@/mixins/dashboard'
import { usageAndResources } from '@/mixins/usageAndResources'

export default {
    name: 'ServicePrices',
    mixins: [dashboard, usageAndResources],
    data() {
        return {
            pricing: [],
            error: false
        }
    },
    created() {
        this.fetchPricing()
    },
    methods: {
        async fetchPricing() {
            try {
                const { data } = await this.$axios.get(`/services/pricing`)
                this.pricing = data
            } catch (error) {
                this.error = true
            }
        }
    }
}
</script>
